import {ONLINECOURSEHOST_ACCENT_COLOR, ONLINECOURSEHOST_PRIMARY_COLOR} from './ui-constants';
import {environment} from '../../environments/environment';
import {Router} from '@angular/router';
import {WebsiteBrand} from '../models/website-brand.model';


export const DEFAULT_THEME: WebsiteBrand = {
  primaryColor: ONLINECOURSEHOST_PRIMARY_COLOR,
  accentColor: ONLINECOURSEHOST_ACCENT_COLOR,
  salesPageBannerColor: ONLINECOURSEHOST_PRIMARY_COLOR,
  salesPageTitleIconColor: ONLINECOURSEHOST_PRIMARY_COLOR,
  salesPageListItemIconColor: ONLINECOURSEHOST_PRIMARY_COLOR,
};

/**
 * Resolves the `--acc` value for the 2026 revamp `.och-r` scope on tenant pages.
 * Returns the tenant brand colour only when the tenant EXPLICITLY customized their
 * branding (themeCustomized); otherwise returns null so the `.och-r` indigo design
 * default applies. Keying off the flag (not the colour value) lets a tenant deliberately
 * use the old platform defaults (#11294f / #EB3B3B) like any other colour.
 */
export function revampAccentColor(brand?: WebsiteBrand | null): string | null {
  if (!brand?.themeCustomized) return null;
  return brand.primaryColor || null;
}



export function checkIfPlatformSite() {

  const hostName = document.location.host;

  return hostName.startsWith("app.") && hostName.includes(environment.domainName);

}

export function getPlatformSubdomain() {

  const hostName = document.location.host;

  // checking if this a tenant subdomain
  const subDomainRegex = new RegExp(`^(.*).${environment.domainName}`);

  const matches = hostName.match(subDomainRegex);

  return matches && matches.length == 2 ? matches[1] : undefined;

}

export function checkIfSingleSignOnPage() {

  const hostName = document.location.host;

  return hostName.startsWith("login") && hostName.includes(environment.domainName);

}

export enum LoginRedirectTarget {
  Courses,
  Community
}

export function createTenantLoginUrl(
  startInCoursesPage = false,
  tenantId: string,
  redirectUrl?: string,
  redirectTarget?: LoginRedirectTarget) {

  const currentPageEncodedUrl = encodeURIComponent(window.location.href);

  let coursesPageEncodedUrl = encodeURIComponent(`${window.location.protocol}//${window.location.host}`);

  switch(redirectTarget) {
    case LoginRedirectTarget.Community:
      coursesPageEncodedUrl += '/community';
      break;
    case LoginRedirectTarget.Courses:
    default:
      coursesPageEncodedUrl += '/courses';
  }

  let tenantLoginUrl = `${environment.authenticationUrl}?redirectUrl=`;

  if (startInCoursesPage) {
    tenantLoginUrl += coursesPageEncodedUrl;
  } else if (redirectUrl) {
    tenantLoginUrl += `${window.location.protocol}//${window.location.host}/${redirectUrl}`;
  } else {
    tenantLoginUrl += currentPageEncodedUrl;
  }

  if (tenantId) {
    tenantLoginUrl += `&tenantId=${tenantId}`;
  }

  return tenantLoginUrl;

}

export const goToLoginPage = (router: Router, startInCoursesPage = false, tenantId:string, redirectUrl?:string) => {

  if (checkIfPlatformSite()) {
    router.navigateByUrl('/platform-login');
    return;
  }

  const tenantLoginUrl = createTenantLoginUrl(startInCoursesPage, tenantId, redirectUrl);

  window.location.href = tenantLoginUrl;

}
